import React from 'react';

import style from './index.module.scss';
import NotFoundImg from '../../../assets/images/NF.png';

const NotFound = () => (
  <div className={style.notFoundWithMargin}>
    <img src={NotFoundImg} alt="Ничего не найдено" />
    <h2 className={style.description}>Мы ничего не нашли Проверьте запрос и попробуйте ещё раз</h2>
  </div>
);

export default NotFound;
